import { userGet } from "./userActions";
import Notify from "./notifyActions";
export const DEVICE_REPOSITORY_LIST = "DEVICE_REPOSITORY_LIST";

export const deviceRepositoryList = (pager, repository) => ({
  type: DEVICE_REPOSITORY_LIST,
  payload: {
    request: {
      mode: "no-cors",
      url: "device-repositories",
      method: "POST",
      data: pager,
      repository
    }
  }
});

export const DEVICE_REPOSITORY_GET = "DEVICE_REPOSITORY_GET";

export const getDeviceRepository = id => ({
  type: DEVICE_REPOSITORY_GET,
  payload: {
    request: {
      mode: "no-cors",
      url: `device-repository/${id}`,
      method: "GET"
    } 
  }
});

export const DEVICE_REPOSITORY_GET_ALL = "DEVICE_REPOSITORY_GET_ALL";

export const getDeviceRepositoryAll = () => ({
  type: DEVICE_REPOSITORY_GET_ALL,
  payload: {
    request: {
      mode: "no-cors",
      url: `device-repository-all`,
      method: "GET"
    }
  }
});

export const DEVICE_REPOSITORY_CREATE = "DEVICE_REPOSITORY_CREATE";
export const DEVICE_REPOSITORY_CREATE_SUCCESSFULL_TOAST = "device_repository_create_successfull_toast";

export const deviceRepositoryCreate = (data, pager) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: DEVICE_REPOSITORY_CREATE,
        payload: {
          request: {
            mode: "no-cors",
            url: "device-repository",
            method: "POST",
            data: { name: data.name, isdefault: data.isdefault }
          }
        }
      }).then(response => {
        if (response.payload.data.success) {
           dispatch(Notify.success(DEVICE_REPOSITORY_CREATE_SUCCESSFULL_TOAST));
          
          if (pager) {
            dispatch(deviceRepositoryList(pager));
          }
          resolve();
        } else {
          reject(response.payload.data);
        }
      });
    });
  };
};

export const DEVICE_REPOSITORY_UPDATE = "DEVICE_REPOSITORY_UPDATE";
export const DEVICE_REPOSITORY_UPDATE_SUCCESSFULL_TOAST = "device_repository_update_successfull_toast";

export const deviceRepositoryUpdate = (data, pager) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: DEVICE_REPOSITORY_UPDATE,
        payload: {
          request: {
            mode: "no-cors",
            url: "device-repository",
            method: "PUT",
            data: { id: data.id, name: data.name, isdefault: data.isdefault }
          }
        }
      }).then(response => {
        if (
          response.payload &&
          response.payload.data &&
          response.payload.data.success
        ) {
            dispatch(Notify.success(DEVICE_REPOSITORY_UPDATE_SUCCESSFULL_TOAST));
          
          dispatch(deviceRepositorySelect(data.id));
          if (pager) {
            dispatch(deviceRepositoryList(pager));
          }
          let state = getState();
          if (state.userReducer.user && state.userReducer.user.Default && state.userReducer.user.id) {
            dispatch(userGet(state.userReducer.user.id));
          }
          resolve();
        } else {
          reject(response.payload.data);
        }
      });
    });
  };
};

export const DEVICE_REPOSITORY_CREATE_RESET = "DEVICE_REPOSITORY_CREATE_RESET";

export const deviceRepositoryCreateReset = () => ({
  type: DEVICE_REPOSITORY_CREATE_RESET
});

export const DEVICE_REPOSITORY_SELECTED = "DEVICE_REPOSITORY_SELECTED";
export const deviceRepositorySelect = cid => {
  return (dispatch, getState) => {
    dispatch({
      type: DEVICE_REPOSITORY_SELECTED,
      payload: {
        request: {
          mode: "no-cors",
          url: `device-repository/${cid}`,
          method: "GET"
        }
      }
    }).then(response => {
      const repository = response.payload.data;
      dispatch(deviceRepositoryLoaded(repository));
    });
  };
};

export const DEVICE_REPOSITORY_LOADED = "DEVICE_REPOSITORY_LOADED";
export const deviceRepositoryLoaded = repository => ({
  type: DEVICE_REPOSITORY_LOADED,
  data: {
    repository
  }
});

export const DEVICE_REPOSITORY_DELETE = "DEVICE_REPOSITORY_DELETE";
export const DEVICE_REPOSITORY_DELETE_SUCCESSFULL_TOAST = "device_repository_delete_successfull_toast";
export const DEVICE_REPOSITORY_DELETE_FAIL_TOAST = "device_repository_delete_fail_toast";

export const deviceRepositoryDelete = (id, pager) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: DEVICE_REPOSITORY_DELETE,
        payload: {
          request: {
            mode: "no-cors",
            url: `device-repository/${id}`,
            method: "DELETE"
          }
        }
      }).then(response => {
        if (response.payload && response.payload.data && response.payload.data.errors == "error_devicesoftwarereleaseexists") {
          dispatch(Notify.error("error_devicesoftwarereleaseexists"));
        } else if (response.payload && response.payload.data && response.payload.data.errors == "error_customerdevicesoftwarereleaseexists") {
          dispatch(Notify.error("error_customerdevicesoftwarereleaseexists"));
        } else {
          dispatch(Notify.success(DEVICE_REPOSITORY_DELETE_SUCCESSFULL_TOAST));
        }
        resolve(true);
        if (pager) {
          dispatch(deviceRepositoryList(pager));
        }
      });
    });
  };
};
 


// WEBPACK FOOTER //
// ./src/redux/actions/deviceRepositoryActions.js